import gql from 'graphql-tag'

const ProcessPaymentMutation = gql`
  mutation processPayment(
    $paymentRequest: PaymentRequest!
    $sendPaymentAsync: Boolean
  ) {
    processPayment(
      paymentRequest: $paymentRequest
      sendPaymentAsync: $sendPaymentAsync
    ) {
      success
      confirmationId
    }
  }
`

const SavePaylianceTokenizedCardMutation = gql`
  mutation savePaylianceTokenizedCard(
    $request: PaylianceTokenizedCardRequestObject!
  ) {
    savePaylianceTokenizedCard(request: $request) {
      lastFourDigitOfCard
      nameOnCard
      expiryDate
      token
    }
  }
`

const UpdateAutopay = gql`
  mutation updateLoanAutopay($autopayUpdateRequest: AutopayUpdateInput!) {
    updateLoanAutopay(autopayUpdateRequest: $autopayUpdateRequest) {
      status
    }
  }
`

const ConfirmAutopayMutation = gql`
  mutation confirmAutopay($input: ConfirmAutopayInput!) {
    confirmAutopay(input: $input) {
      status
    }
  }
`

export default {
  ProcessPaymentMutation,
  SavePaylianceTokenizedCardMutation,
  UpdateAutopay,
  ConfirmAutopayMutation,
}
export {
  ProcessPaymentMutation,
  SavePaylianceTokenizedCardMutation,
  UpdateAutopay,
  ConfirmAutopayMutation,
}
